"use strict";

var React = require("react/addons");
var createReactClass = require("create-react-class");
var classnames = require("_lib/utils/classnames").default;

var ErrorDialog = createReactClass({
  /* lifecycle methods */
  getInitialState: function () {
    return {};
  },

  /* publics */

  /* privates */
  _close: function (e) {
    this.props.close();
  },

  /* render */
  render: function () {
    /* jshint ignore:start */

    var classes = classnames({
      Dialog: true,
      error: true,
    });

    return (
      <div className={classes}>
        <div className="title-container">
          <div className="text">
            <i className="fa fa-exclamation-triangle" />
            {this.props.dialogObject.title}
          </div>
        </div>
        <p>{this.props.dialogObject.message}</p>
      </div>
    );

    /*
				<div className='action-bar'>
					<div className='cancel-button' onClick={this._close}>Close</div>
				</div>
		*/
  },
});

module.exports = ErrorDialog;
